import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HgBlogRoutingModule } from './hg-blog-routing.module';
import { HgBlogsComponent } from './hg-blogs/hg-blogs.component';
import { HgBlogComponent } from './hg-blog.component';
import { BlogHeaderComponent } from './blog-header/blog-header.component';
import { BlogFooterComponent } from './blog-footer/blog-footer.component';
import { FormsModule } from '@angular/forms';

import { BlogArticleComponent } from './blog-article/blog-article.component';
import { Article1Component } from './hg-blogs/article1/article1.component';
import { Article2Component } from './hg-blogs/article2/article2.component';
import { Article3Component } from './hg-blogs/article3/article3.component';
import { Article4Component } from './hg-blogs/article4/article4.component';

import { SanitizerHtmlPipe } from './santizer.pipe';

@NgModule({
  imports: [
    CommonModule,
    HgBlogRoutingModule,
    FormsModule
  ],
  declarations: [ HgBlogComponent, HgBlogsComponent, BlogHeaderComponent, BlogFooterComponent, BlogArticleComponent, SanitizerHtmlPipe, Article1Component,
    Article2Component, Article3Component, Article4Component]
})
export class HgBlogModule { }
